const words = ["Kitchens", "Bathrooms", "Decks & Patios", "Flooring", "Painting", "Repairs", "Carpentry", "Family-owned"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-serif-d text-5xl sm:text-7xl italic font-medium text-[#1E1B18] whitespace-nowrap">{w}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-8 sm:w-8 text-[#C85A32]" fill="currentColor"><path d="M12 2 L22 11 H18 V22 H6 V11 H2 Z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-[#E2DDD5] bg-[#EFECE6] py-8 sm:py-10" data-testid="services-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
